import axios, { AxiosInstance } from 'axios';

// Расширяем тип AxiosInstance для добавления наших методов
declare module 'axios' {
  interface AxiosInstance {
    getProducts: (page: number, limit: number, filters: any) => Promise<any>;
    getProductById: (id: string) => Promise<any>;
    getProductTzDetail: (productId: string) => Promise<{ success: boolean; data: any }>;
    getProductsStats: () => Promise<any>;
    getProductsFilterOptions: () => Promise<any>;
    getStatuses: () => Promise<any>;
    remapProductsSubject: (data: {
      source_code: string;
      from_subject_id: number;
      to_subject_id: number;
      apply_all?: boolean;
      product_id?: string;
    }) => Promise<{
      success: boolean;
      updated: number;
      apply_all?: boolean;
      product_id?: string | null;
      source_code: string;
      from_subject_id: number;
      to_subject_id: number;
      purchase_percent?: number | null;
      error?: string;
    }>;
    changeProductStatus: (productId: string, statusId: string) => Promise<any>;
    changeProductStatusBatch: (productIds: string[], statusId: string) => Promise<any>;
    updateProduct: (productId: string, data: {
      order_quantity?: string | number | null;
      cert_id?: string | number | null;
      required_price?: number | null;
      package_length?: number | null;
      package_width?: number | null;
      package_height?: number | null;
      article?: string | null;
      name?: string | null;
      commission_fbo?: number | null;
      purchase_percent?: number | null;
      target_price_cny?: number | null;
      target_price_rub?: number | null;
      target_price_cny_ozon?: number | null;
      target_price_rub_ozon?: number | null;
      target_price_cny_wb?: number | null;
      target_price_rub_wb?: number | null;
    }) => Promise<any>;
    addToStopList: (productId: string) => Promise<any>;
    confirmNewProduct: (productId: string, confirmed: boolean, payload?: {
      target_price_cny?: number | null;
      target_price_rub?: number | null;
      target_price_cny_ozon?: number | null;
      target_price_rub_ozon?: number | null;
      target_price_cny_wb?: number | null;
      target_price_rub_wb?: number | null;
    }) => Promise<any>;
    getSppMarketplace: () => Promise<{ success: boolean; data: any[] }>;
    getFboWb: () => Promise<{ success: boolean; data: any[] }>;
    getFboOzon: () => Promise<{ success: boolean; data: Record<string, number> }>;
    getSimilarProducts: (productId: string, limit: number) => Promise<any>;
    getConstants: () => Promise<any>;
    getCertificates: () => Promise<any>;
    getCurrentUser: () => Promise<any>;
    login: (credentials: { email: string; password: string }) => Promise<any>;
    impersonateExchange: (code: string) => Promise<any>;
    logout: () => Promise<any>;
    register: (username: string, email: string, password: string) => Promise<any>;
    updatePassword: (currentPassword: string, newPassword: string) => Promise<any>;
    refreshToken: () => Promise<any>;
    setToken: (token: string | null) => void;
    getTechnicalSpecs: (page: number, limit: number, filters: any) => Promise<any>;
    getTechnicalSpecsNewWave: (page: number, limit: number, filters: any) => Promise<any>;
    updateTechnicalSpec: (productId: string, desc: string) => Promise<any>;
    updateTechnicalSpecFields: (productId: string, fields: { eng_name?: string; eng_desc?: string; season?: string }) => Promise<any>;
    confirmTZ: (productId: string, confirmed: boolean) => Promise<any>;
    confirmTZFull: (productId: string, data: { confirmed: boolean; desc?: string; eng_name?: string; eng_desc?: string }) => Promise<any>;
    uploadImage: (productId: string, imageFile: File, imageIndex: number) => Promise<any>;
    deleteImage: (productId: string, imageIndex: number) => Promise<any>;
    swapImages: (productId: string, fromIndex: number, toIndex: number) => Promise<any>;
    generateDescription: (productId: string, templateId: string, onStep?: (step: string) => void) => Promise<any>;
    pollTzJob: (productId: string, jobId: string, onStep?: (step: string) => void) => Promise<any>;
    getTzTemplates: () => Promise<any>;
    getTzModels: () => Promise<any>;
    getTzUsage: () => Promise<any>;
    getTzBlocks: () => Promise<any>;
    createTzBlock: (body: { name: string; body: string }) => Promise<any>;
    updateTzBlock: (id: string, body: { name: string; body: string }) => Promise<any>;
    deleteTzBlock: (id: string) => Promise<any>;
    createTzTemplate: (body: any) => Promise<any>;
    updateTzTemplate: (id: string, body: any) => Promise<any>;
    duplicateTzTemplate: (id: string) => Promise<any>;
    deleteTzTemplate: (id: string) => Promise<any>;
    getTzFeedback: (id: string) => Promise<any>;
    rateTzTemplate: (id: string, body: { score: number; subject_id?: number | null }) => Promise<any>;
    commentTzTemplate: (id: string, body: string) => Promise<any>;
    deleteTzComment: (id: string, commentId: string) => Promise<any>;
    setTzBinding: (body: { scope: string; template_id: string; subject_id?: number; source_code?: string | null }) => Promise<any>;
    clearTzBinding: (scope: string, subjectId?: number, sourceCode?: string) => Promise<any>;
    getProductPackageInfo: (productId: string) => Promise<any>;
    updateProductPackageInfo: (productId: string, packageInfo: Record<string, number[]>) => Promise<any>;
    getAnalystUsers: () => Promise<any>;
    transferSubject: (subjectId: number, toUserId: string) => Promise<any>;
    changeSubjectProductsStatus: (subjectId: number, fromStatusId: string, toStatusId: string) => Promise<any>;
    getProductGraphs: (productId: string) => Promise<any>;
    getWBCard: (productId: string, baseUrl: string) => Promise<any>;
    getProductBySku: (sku: string) => Promise<any>;
    getTzConfirmedWeekCount: () => Promise<{ count: number }>;
    getWeeklyStatistics: (dateFrom: string, dateTo: string, userId?: string) => Promise<{ summary: any; byDay: any[]; byActionType: any[]; bySubject: any[]; tzConfirmedArticles: any[] }>;
    getWeeklyStatisticsExport: (dateFrom: string, dateTo: string, userId?: string) => Promise<Blob>;
    getWeeklyDetail: (metric: 'inWork' | 'statusChanges' | 'newProducts' | 'tzConfirmed', dateFrom: string, dateTo: string, userId?: string) => Promise<{
      success: boolean; metric: string; dateFrom: string | null; dateTo: string | null;
      products: { id: number; article: string; name: string; new_wave: boolean; created_at?: string | null; updated_at?: string | null; subject_name?: string }[];
    }>;
    getSubjectDetail: (subjectId: number, dateFrom: string, dateTo: string, userId?: string) => Promise<{
      success: boolean; subjectId: number; subjectName: string; dateFrom: string; dateTo: string;
      inWork: { id: number; article: string; name: string; new_wave: boolean; created_at?: string | null; updated_at?: string | null }[];
      statusChanges: { id: number; article: string; name: string; new_wave: boolean; created_at?: string | null; updated_at?: string | null }[];
      newProducts: { id: number; article: string; name: string; new_wave: boolean; created_at?: string | null; updated_at?: string | null }[];
      tzConfirmed: { id: number; article: string; name: string; new_wave: boolean; created_at?: string | null; updated_at?: string | null }[];
    }>;
    getProductAuditLog: (productId: string, page?: number, limit?: number) => Promise<{ data: any[]; total: number; page: number; totalPages: number }>;
    getStatisticsAuditLog: (actionType: string, dateFrom: string, dateTo: string, page?: number, limit?: number) => Promise<{ data: any[]; total: number; page: number; totalPages: number }>;
    saveNewWaveProduct: (productId: string, productData: any, imageFile?: File) => Promise<any>;
    getNewWaveProducts: (page?: number, limit?: number) => Promise<{ data: any[]; total: number; page: number; limit: number; totalPages: number }>;
    checkSkuAvailability: (sku: string) => Promise<any>;
    getAllSubjects: () => Promise<any>;
    deleteNewWaveProduct: (productId: string) => Promise<any>;
    getCheckerSearch: (params: { sku?: string; subject_name?: string; checker_limit?: number; checker_offset?: number; products_limit?: number; products_offset?: number }) => Promise<import('axios').AxiosResponse<{ success: boolean; checker: any[]; products: any[]; searchedItem?: { thumb_url: string; label: string } | null; visual?: boolean; hasCheckerMore?: boolean; hasProductsMore?: boolean; error?: string }>>;
    getCheckerSuggestions: (q: string) => Promise<import('axios').AxiosResponse<{ success: boolean; suggestions: string[] }>>;
  }
}

// Функция для определения базового URL API
const getApiBaseURL = (): string => {
  // Dev: прямой URL из client/.env — CRA proxy на :5003 часто отдаёт 404 на /api/*
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/$/, '');
  }
  // Prod / без REACT_APP_API_URL: относительный путь (Nginx / package.json proxy)
  return '/api';
};

// Создаем экземпляр axios с базовой конфигурацией
const api = axios.create({
  baseURL: getApiBaseURL(),
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Интерцептор для добавления токена авторизации
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    console.log('API request interceptor - token:', token ? 'present' : 'missing');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Интерцептор для обработки ответов
api.interceptors.response.use(
  (response) => {
    console.log('API response interceptor - status:', response.status, 'url:', response.config.url);
    return response;
  },
  (error) => {
    console.error('API response interceptor - error:', error);
    console.error('Error status:', error.response?.status);
    console.error('Error data:', error.response?.data);
    if (error.response?.status === 401) {
      const url = String(error.config?.url || '');
      if (url.includes('/auth/impersonate-exchange')) {
        return Promise.reject(error);
      }
      // 401 от внешних API (MPStats и т.п.), проброшенный бэкендом — не наша сессия
      const errMsg = String(error.response?.data?.error || '');
      if (/MPStats|External API|INGEST_TOKEN/i.test(errMsg)) {
        return Promise.reject(error);
      }
      // Токен истек или недействителен
      console.log('Token expired, redirecting to login');
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const TZ_JOBS_KEY = 'tz-active-jobs';
const TZ_RESULTS_KEY = 'tz-job-results';
const TZ_WAIT_MS = 12 * 60 * 60 * 1000;

function loadTzJobs(): Record<string, { jobId: string; step: string }> {
  try {
    const raw = JSON.parse(sessionStorage.getItem(TZ_JOBS_KEY) || '{}');
    return raw && typeof raw === 'object' ? raw : {};
  } catch {
    return {};
  }
}

function loadTzResults(): Record<string, { desc?: string; eng_desc?: string; season?: string; at?: number }> {
  try {
    const raw = JSON.parse(sessionStorage.getItem(TZ_RESULTS_KEY) || '{}');
    return raw && typeof raw === 'object' ? raw : {};
  } catch {
    return {};
  }
}

function saveTzJob(productId: string, jobId: string, step: string) {
  const jobs = loadTzJobs();
  jobs[String(productId)] = { jobId, step };
  sessionStorage.setItem(TZ_JOBS_KEY, JSON.stringify(jobs));
}

function forgetTzJob(productId: string) {
  const jobs = loadTzJobs();
  delete jobs[String(productId)];
  sessionStorage.setItem(TZ_JOBS_KEY, JSON.stringify(jobs));
}

function forgetTzJobIf(productId: string, jobId: string) {
  const jobs = loadTzJobs();
  const key = String(productId);
  if (jobs[key]?.jobId !== jobId) return;
  delete jobs[key];
  sessionStorage.setItem(TZ_JOBS_KEY, JSON.stringify(jobs));
}

function saveTzResult(productId: string, data: { desc?: string; eng_desc?: string; season?: string; at?: number }) {
  const results = loadTzResults();
  const stored = { ...(data || {}), at: data?.at || Date.now() };
  results[String(productId)] = stored;
  sessionStorage.setItem(TZ_RESULTS_KEY, JSON.stringify(results));
  return stored;
}

function forgetTzResult(productId: string) {
  const results = loadTzResults();
  delete results[String(productId)];
  sessionStorage.setItem(TZ_RESULTS_KEY, JSON.stringify(results));
}

function stopTzJob(productId: string, jobId: string, error: unknown): never {
  forgetTzJobIf(productId, jobId);
  const message = error instanceof Error ? error.message : 'Не удалось сгенерировать';
  const wrapped = new Error(message || 'Не удалось сгенерировать');
  if (message === 'Отменено') wrapped.name = 'TzCancelled';
  throw wrapped;
}

const tzListeners = new Set<() => void>();
const tzWatchers = new Map<string, { promise: Promise<any>; jobId: string; stop: () => void }>();

function emitTzJobs() {
  tzListeners.forEach((listener) => listener());
}

function subscribeTzJobs(listener: () => void) {
  tzListeners.add(listener);
  return () => {
    tzListeners.delete(listener);
  };
}

async function pollTzJob(
  productId: string,
  jobId: string,
  onStep: ((step: string) => void) | undefined,
  isStopped: () => boolean,
  bindAbort: (controller: AbortController) => void,
) {
  const deadline = Date.now() + TZ_WAIT_MS;
  let misses = 0;
  while (Date.now() < deadline) {
    if (isStopped()) stopTzJob(productId, jobId, new Error('Отменено'));
    const controller = new AbortController();
    bindAbort(controller);
    try {
      const status = await api.get(`/products/${productId}/generate-description/status`, {
        params: { jobId },
        timeout: 15000,
        signal: controller.signal,
      });
      if (isStopped()) stopTzJob(productId, jobId, new Error('Отменено'));
      misses = 0;
      const data = status.data?.data || {};
      if (data.step) onStep?.(data.step);
      if (data.error) stopTzJob(productId, jobId, new Error(data.error));
      if (data.done) return data.data || {};
    } catch (error: any) {
      if (isStopped() || error?.name === 'TzCancelled' || error?.code === 'ERR_CANCELED') {
        stopTzJob(productId, jobId, new Error('Отменено'));
      }
      if (error.response?.status) stopTzJob(productId, jobId, new Error(error.response?.data?.error || error.message));
      if (!error.request) throw error;
      misses += 1;
      if (misses >= 10) stopTzJob(productId, jobId, new Error('Нет связи с сервером'));
    }
    await new Promise((resolve) => setTimeout(resolve, 2000));
  }
  stopTzJob(productId, jobId, new Error('Генерация шла слишком долго'));
}

function watchTzJob(productId: string, jobId: string, initialStep?: string, onStep?: (step: string) => void) {
  const key = String(productId);
  const existing = tzWatchers.get(key);
  if (existing?.jobId === jobId) return existing.promise;
  existing?.stop();
  let stopped = false;
  let abortPoll: AbortController | null = null;
  const stop = () => {
    stopped = true;
    abortPoll?.abort();
  };
  const step = initialStep || loadTzJobs()[key]?.step || 'В очереди';
  saveTzJob(key, jobId, step);
  onStep?.(step);
  emitTzJobs();
  const run = pollTzJob(key, jobId, (next) => {
    if (loadTzJobs()[key]?.jobId !== jobId) return;
    saveTzJob(key, jobId, next);
    onStep?.(next);
    emitTzJobs();
  }, () => stopped, (controller) => {
    abortPoll = controller;
  }).then((data) => {
    const stored = saveTzResult(key, data);
    forgetTzJobIf(key, jobId);
    emitTzJobs();
    return stored;
  }).catch((error) => {
    forgetTzJobIf(key, jobId);
    emitTzJobs();
    throw error;
  }).finally(() => {
    if (tzWatchers.get(key)?.jobId === jobId) tzWatchers.delete(key);
  });
  tzWatchers.set(key, { promise: run, jobId, stop });
  return run;
}

function ensureTzWatchers(onError?: (message: string) => void) {
  Object.entries(loadTzJobs()).forEach(([productId, job]) => {
    if (tzWatchers.has(productId)) return;
    watchTzJob(productId, job.jobId, job.step).catch((error) => {
      if (error?.name === 'TzCancelled' || error?.message === 'Отменено') return;
      onError?.(error?.message || 'Не удалось сгенерировать');
    });
  });
}

function cancelTzGeneration(productId: string) {
  const key = String(productId);
  const jobId = loadTzJobs()[key]?.jobId;
  tzWatchers.get(key)?.stop();
  forgetTzJob(key);
  emitTzJobs();
  if (!jobId) return Promise.resolve();
  return api.post(`/products/${key}/generate-description/cancel`, { jobId }, { timeout: 15000 }).then(() => undefined).catch(() => undefined);
}

// API методы
const apiService = {
  // Товары
  getProducts: (page: number, limit: number, filters: any) => {
    console.log('api.getProducts - filters received:', filters);
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(filters?.search && { search: filters.search }),
      ...(filters?.subject_id && { subject_id: filters.subject_id }),
      ...(filters?.country && { country: filters.country }),
      ...(filters?.min_price && { min_price: filters.min_price }),
      ...(filters?.max_price && { max_price: filters.max_price }),
      ...(filters?.min_revenue && { min_revenue: filters.min_revenue }),
      ...(filters?.max_revenue && { max_revenue: filters.max_revenue }),
      ...(filters?.status_id && { status_id: filters.status_id }),
      ...(filters?.exclude_phrase && { exclude_phrase: filters.exclude_phrase }),
      ...(filters?.sort_field && { sort_field: filters.sort_field }),
      ...(filters?.sort_direction && { sort_direction: filters.sort_direction }),
      ...(filters?.exclude_stop_list !== undefined && { exclude_stop_list: filters.exclude_stop_list.toString() }),
      ...(filters?.exclude_confirmed !== undefined && { exclude_confirmed: filters.exclude_confirmed.toString() }),
      ...(filters?.source_code && { source_code: filters.source_code }),
    });
    console.log('api.getProducts - URL params:', params.toString());
    return api.get(`/products?${params}`);
  },
  
  getProductById: (id: string) => {
    return api.get(`/products/${id}`);
  },

  getProductTzDetail: async (productId: string): Promise<{ success: boolean; data: any }> => {
    const response = await api.get(`/products/${productId}/tz-detail`);
    return response.data;
  },
  
  getProductsStats: () => {
    return api.get('/products/stats/summary');
  },
  
  getProductsFilterOptions: () => {
    return api.get('/products/filter-options');
  },

  remapProductsSubject: async (data: {
    source_code: string;
    from_subject_id: number;
    to_subject_id: number;
    apply_all?: boolean;
    product_id?: string;
  }) => {
    const response = await api.post('/products/remap-subject', data);
    return response.data;
  },
  
  // Статусы
    getStatuses: () => {
    return api.get('/statuses');
  },
  
  getAllSubjects: () => {
    return api.get('/subjects');
  },
  
  changeProductStatus: (productId: string, statusId: string) => {
    return api.patch(`/products/${productId}/status`, { status_id: statusId });
  },
  
  changeProductStatusBatch: (productIds: string[], statusId: string) => {
    return api.post('/products/batch-status', { 
      productIds: productIds,
      status_id: statusId 
    });
  },
  
  updateProduct: (productId: string, data: {
    order_quantity?: string | number | null;
    cert_id?: string | number | null;
    required_price?: number | null;
    package_length?: number | null;
    package_width?: number | null;
    package_height?: number | null;
    article?: string | null;
    name?: string | null;
    commission_fbo?: number | null;
    purchase_percent?: number | null;
    target_price_cny?: number | null;
    target_price_rub?: number | null;
    target_price_cny_ozon?: number | null;
    target_price_rub_ozon?: number | null;
    target_price_cny_wb?: number | null;
    target_price_rub_wb?: number | null;
  }) => {
    return api.patch(`/products/${productId}`, data);
  },
  
  confirmNewProduct: (productId: string, confirmed: boolean, payload?: {
    target_price_cny?: number | null;
    target_price_rub?: number | null;
    target_price_cny_ozon?: number | null;
    target_price_rub_ozon?: number | null;
    target_price_cny_wb?: number | null;
    target_price_rub_wb?: number | null;
  }) => {
    const body: any = { confirmed };
    if (payload?.target_price_cny !== undefined) body.target_price_cny = payload.target_price_cny;
    if (payload?.target_price_rub !== undefined) body.target_price_rub = payload.target_price_rub;
    if (payload?.target_price_cny_ozon !== undefined) body.target_price_cny_ozon = payload.target_price_cny_ozon;
    if (payload?.target_price_rub_ozon !== undefined) body.target_price_rub_ozon = payload.target_price_rub_ozon;
    if (payload?.target_price_cny_wb !== undefined) body.target_price_cny_wb = payload.target_price_cny_wb;
    if (payload?.target_price_rub_wb !== undefined) body.target_price_rub_wb = payload.target_price_rub_wb;
    return api.patch(`/products/${productId}/confirm-new-product`, body);
  },

  getSppMarketplace: async () => {
    const response = await api.get('/new-formula/spp-marketplace');
    return response.data as { success: boolean; data: any[] };
  },
  getFboWb: async () => {
    const response = await api.get('/new-formula/fbo-wb');
    return response.data as { success: boolean; data: any[] };
  },
  getFboOzon: async () => {
    const response = await api.get('/new-formula/fbo-ozon');
    return response.data as { success: boolean; data: Record<string, number> };
  },
  
  addToStopList: (productId: string) => {
    return api.patch(`/products/${productId}/stop-list`, {});
  },
  
  // Похожие товары
  getSimilarProducts: (productId: string, limit: number) => {
    return api.get(`/products/similar/${productId}?limit=${limit}`);
  },
  
  // Константы
  getConstants: () => {
    return api.get('/constants');
  },
  
  // Сертификаты
  getCertificates: () => {
    return api.get('/certificates');
  },
  
  // Пользователь
  getCurrentUser: () => {
    return api.get('/auth/me');
  },
  
  login: (credentials: { email: string; password: string }) => {
    return api.post('/auth/login', credentials);
  },

  impersonateExchange: (code: string) => {
    return api.post('/auth/impersonate-exchange', { code });
  },
  
  logout: () => {
    return api.post('/auth/logout');
  },
  
  register: (username: string, email: string, password: string) => {
    return api.post('/auth/register', { username, email, password });
  },
  
  updatePassword: (currentPassword: string, newPassword: string) => {
    return api.patch('/auth/password', { currentPassword, newPassword });
  },
  
  refreshToken: () => {
    return api.post('/auth/refresh');
  },
  
  setToken: (token: string | null) => {
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete api.defaults.headers.common['Authorization'];
    }
  },
  
  // Технические задания
  getTechnicalSpecs: (page: number, limit: number, filters: any) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(filters?.status_id && { status_id: filters.status_id }),
      ...(filters?.search && { search: filters.search }),
      ...(filters?.subject_id && { subject_id: filters.subject_id }),
      ...(filters?.country && { country: filters.country }),
      ...(filters?.exclude_phrase && { exclude_phrase: filters.exclude_phrase }),
      ...(filters?.sort_field && { sort_field: filters.sort_field }),
      ...(filters?.sort_direction && { sort_direction: filters.sort_direction }),
      ...(filters?.tz_unconfirmed === 'true' && { tz_unconfirmed: 'true' }),
      ...(filters?.exclude_stop_list !== undefined && { exclude_stop_list: String(filters.exclude_stop_list) }),
      ...(filters?.source_code && { source_code: filters.source_code })
    });
    console.log('Making API request to:', `/products/technical-specs?${params}`);
    console.log('Filters:', filters);
    return api.get(`/products/technical-specs?${params}`);
  },

  getTechnicalSpecsNewWave: (page: number, limit: number, filters: any) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(filters?.status_id && { status_id: filters.status_id }),
      ...(filters?.search && { search: filters.search }),
      ...(filters?.subject_id && { subject_id: filters.subject_id }),
      ...(filters?.country && { country: filters.country }),
      ...(filters?.exclude_phrase && { exclude_phrase: filters.exclude_phrase }),
      ...(filters?.sort_field && { sort_field: filters.sort_field }),
      ...(filters?.sort_direction && { sort_direction: filters.sort_direction }),
      ...(filters?.tz_unconfirmed === 'true' && { tz_unconfirmed: 'true' }),
      ...(filters?.exclude_stop_list !== undefined && { exclude_stop_list: String(filters.exclude_stop_list) }),
      ...(filters?.source_code && { source_code: filters.source_code })
    });
    console.log('Making API request to:', `/products/technical-specs-new-wave?${params}`);
    console.log('Filters:', filters);
    return api.get(`/products/technical-specs-new-wave?${params}`);
  },

  getProductPackageInfo: (productId: string) => {
    return api.get(`/products/${productId}/package-info`);
  },

  updateProductPackageInfo: (productId: string, packageInfo: Record<string, number[]>) => {
    return api.put(`/products/${productId}/package-info`, { packageInfo });
  },
  
  updateTechnicalSpec: (productId: string, desc: string) => {
    return api.patch(`/products/${productId}/technical-spec`, { desc });
  },
  
  updateTechnicalSpecFields: (productId: string, fields: { eng_name?: string; eng_desc?: string; season?: string }) => {
    return api.patch(`/products/${productId}/technical-spec`, fields);
  },
  
  confirmTZ: (productId: string, confirmed: boolean) => {
    return api.patch(`/products/${productId}/confirm-tz`, { confirmed });
  },
  
  confirmTZFull: (productId: string, data: { confirmed: boolean; desc?: string; eng_name?: string; eng_desc?: string }) => {
    return api.patch(`/products/${productId}/confirm-tz`, data);
  },
  
  uploadImage: (productId: string, imageFile: File, imageIndex: number) => {
    console.log('Uploading image:', { productId, imageFile, imageIndex });
    const formData = new FormData();
    formData.append('image', imageFile);
    formData.append('imageIndex', imageIndex.toString());
    console.log('FormData contents:', Array.from(formData.entries()));
    return api.post(`/products/${productId}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  deleteImage: (productId: string, imageIndex: number) => {
    return api.delete(`/products/${productId}/images/${imageIndex}`);
  },
  
  swapImages: (productId: string, fromIndex: number, toIndex: number) => {
    return api.patch(`/products/${productId}/images/swap`, { fromIndex, toIndex });
  },
  
  generateDescription: async (productId: string, templateId: string, onStep?: (step: string) => void) => {
    const started = await api.post(`/products/${productId}/generate-description`, { templateId }, { timeout: 30000 });
    const jobId = started.data?.data?.jobId;
    if (!jobId) throw new Error('Не удалось начать генерацию');
    const step = started.data?.data?.step || 'В очереди';
    return watchTzJob(productId, jobId, step, onStep);
  },

  pollTzJob: (productId: string, jobId: string, onStep?: (step: string) => void) => watchTzJob(productId, jobId, undefined, onStep),

  getTzTemplates: () => api.get('/tz-templates'),
  getTzModels: () => api.get('/tz-templates/models'),
  getTzUsage: () => api.get('/tz-templates/usage'),
  getTzBlocks: () => api.get('/tz-templates/blocks'),
  createTzBlock: (body: { name: string; body: string }) => api.post('/tz-templates/blocks', body),
  updateTzBlock: (id: string, body: { name: string; body: string }) => api.patch(`/tz-templates/blocks/${id}`, body),
  deleteTzBlock: (id: string) => api.delete(`/tz-templates/blocks/${id}`),
  createTzTemplate: (body: any) => api.post('/tz-templates', body),
  updateTzTemplate: (id: string, body: any) => api.patch(`/tz-templates/${id}`, body),
  duplicateTzTemplate: (id: string) => api.post(`/tz-templates/${id}/duplicate`),
  deleteTzTemplate: (id: string) => api.delete(`/tz-templates/${id}`),
  getTzFeedback: (id: string) => api.get(`/tz-templates/${id}/feedback`),
  rateTzTemplate: (id: string, body: { score: number; subject_id?: number | null }) => api.post(`/tz-templates/${id}/rating`, body),
  commentTzTemplate: (id: string, body: string) => api.post(`/tz-templates/${id}/comments`, { body }),
  deleteTzComment: (id: string, commentId: string) => api.delete(`/tz-templates/${id}/comments/${commentId}`),
  setTzBinding: (body: { scope: string; template_id: string; subject_id?: number; source_code?: string | null }) => api.post('/tz-templates/bindings', body),
  clearTzBinding: (scope: string, subjectId?: number, sourceCode?: string) => api.delete('/tz-templates/bindings', {
    params: { scope, subject_id: subjectId, source_code: sourceCode || undefined },
  }),
  
  // Пользователи и передача предметов
  getAnalystUsers: () => {
    return api.get('/users/analysts');
  },
  
  transferSubject: (subjectId: number, toUserId: string) => {
    return api.post('/subjects/transfer', {
      subject_id: subjectId,
      to_user_id: toUserId
    });
  },

  changeSubjectProductsStatus: (subjectId: number, fromStatusId: string, toStatusId: string) => {
    return api.post(`/subjects/${subjectId}/batch-status-change`, {
      from_status_id: fromStatusId,
      to_status_id: toStatusId
    });
  },
  
  // Графики и данные карточки товара
  getProductGraphs: (productId: string) => {
    return api.get(`/products/${productId}/graphs`);
  },
  
  getWBCard: (productId: string, baseUrl: string) => {
    return api.get(`/products/${productId}/wb-card`, {
      params: { baseUrl }
    });
  },
  
  // New Wave
  getProductBySku: (sku: string) => {
    return api.post('/new-wave/fetch-sku', { sku });
  },

  getTzConfirmedWeekCount: async (): Promise<{ count: number }> => {
    const response = await api.get<{ count: number }>('/products/tz-confirmed-week-count');
    return { count: response.data.count };
  },

  getWeeklyStatistics: async (dateFrom: string, dateTo: string, userId?: string): Promise<{ summary: any; byDay: any[]; byActionType: any[]; bySubject: any[]; tzConfirmedArticles: any[] }> => {
    const params: { dateFrom: string; dateTo: string; userId?: string } = { dateFrom, dateTo };
    if (userId) params.userId = userId;
    const response = await api.get('/statistics/weekly', { params });
    return {
      summary: response.data.summary,
      byDay: response.data.byDay || [],
      byActionType: response.data.byActionType || [],
      bySubject: response.data.bySubject || [],
      tzConfirmedArticles: response.data.tzConfirmedArticles || []
    };
  },

  getWeeklyStatisticsExport: async (dateFrom: string, dateTo: string, userId?: string): Promise<Blob> => {
    const params: { dateFrom: string; dateTo: string; userId?: string } = { dateFrom, dateTo };
    if (userId) params.userId = userId;
    const response = await api.get('/statistics/weekly/export', { params, responseType: 'blob' });
    return response.data as Blob;
  },

  getWeeklyDetail: async (
    metric: 'inWork' | 'statusChanges' | 'newProducts' | 'tzConfirmed',
    dateFrom: string,
    dateTo: string,
    userId?: string
  ): Promise<{
    success: boolean;
    metric: string;
    dateFrom: string | null;
    dateTo: string | null;
    products: { id: number; article: string; name: string; new_wave: boolean; created_at?: string | null; updated_at?: string | null; subject_name?: string }[];
  }> => {
    const params: { dateFrom: string; dateTo: string; metric: string; userId?: string } = { dateFrom, dateTo, metric };
    if (userId) params.userId = userId;
    const response = await api.get('/statistics/weekly/detail', { params });
    return response.data;
  },

  getSubjectDetail: async (
    subjectId: number,
    dateFrom: string,
    dateTo: string,
    userId?: string
  ): Promise<{
    success: boolean;
    subjectId: number;
    subjectName: string;
    dateFrom: string;
    dateTo: string;
    inWork: { id: number; article: string; name: string; new_wave: boolean; created_at?: string | null; updated_at?: string | null }[];
    statusChanges: { id: number; article: string; name: string; new_wave: boolean; created_at?: string | null; updated_at?: string | null }[];
    newProducts: { id: number; article: string; name: string; new_wave: boolean; created_at?: string | null; updated_at?: string | null }[];
    tzConfirmed: { id: number; article: string; name: string; new_wave: boolean; created_at?: string | null; updated_at?: string | null }[];
  }> => {
    const params: { dateFrom: string; dateTo: string; userId?: string } = { dateFrom, dateTo };
    if (userId) params.userId = userId;
    const response = await api.get(`/statistics/subject/${subjectId}/detail`, { params });
    return response.data;
  },

  getProductAuditLog: async (productId: string, page: number = 1, limit: number = 50): Promise<{ data: any[]; total: number; page: number; totalPages: number }> => {
    const response = await api.get(`/products/${productId}/audit-log`, { params: { page, limit } });
    return {
      data: response.data.data || [],
      total: response.data.total || 0,
      page: response.data.page || 1,
      totalPages: response.data.totalPages || 1
    };
  },

  getStatisticsAuditLog: async (actionType: string, dateFrom: string, dateTo: string, page: number = 1, limit: number = 20): Promise<{ data: any[]; total: number; page: number; totalPages: number }> => {
    const response = await api.get('/statistics/audit-log', { params: { actionType, dateFrom, dateTo, page, limit } });
    return {
      data: response.data.data || [],
      total: response.data.total || 0,
      page: response.data.page || 1,
      totalPages: response.data.totalPages || 1
    };
  },
  
  saveNewWaveProduct: (productId: string, productData: any, imageFile?: File) => {
    const formData = new FormData();
    formData.append('productData', JSON.stringify(productData));
    if (imageFile) {
      formData.append('image', imageFile);
    }
    return api.post('/new-wave/save-product', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  getNewWaveProducts: async (page = 1, limit = 50) => {
    const res = await api.get<{ success: boolean; data: any[]; total: number; page: number; limit: number; totalPages: number }>('/new-wave/products', { params: { page, limit } });
    return res.data;
  },

  checkSkuAvailability: (sku: string) => {
    return api.get(`/new-wave/check-sku/${sku}`);
  },

  getCheckerSearch: (params: { sku?: string; subject_name?: string; checker_limit?: number; checker_offset?: number; products_limit?: number; products_offset?: number }) => {
    return api.get('/products/checker-search', { params });
  },
  getCheckerSuggestions: (q: string) => {
    return api.get('/products/checker-suggestions', { params: { q } });
  },

  deleteNewWaveProduct: (productId: string) => {
    return api.delete(`/new-wave/products/${productId}`);
  }
};

// Добавляем методы к самому объекту api для обратной совместимости
api.getProducts = apiService.getProducts;
api.getProductById = apiService.getProductById;
api.getProductTzDetail = apiService.getProductTzDetail;
api.getProductsStats = apiService.getProductsStats;
api.getProductsFilterOptions = apiService.getProductsFilterOptions;
api.getStatuses = apiService.getStatuses;
api.changeProductStatus = apiService.changeProductStatus;
api.changeProductStatusBatch = apiService.changeProductStatusBatch;
api.updateProduct = apiService.updateProduct;
api.confirmNewProduct = apiService.confirmNewProduct;
api.getSimilarProducts = apiService.getSimilarProducts;
api.getConstants = apiService.getConstants;
api.getCertificates = apiService.getCertificates;
api.getSppMarketplace = apiService.getSppMarketplace;
api.getFboWb = apiService.getFboWb;
api.getFboOzon = apiService.getFboOzon;
api.getCurrentUser = apiService.getCurrentUser;
api.login = apiService.login;
api.impersonateExchange = apiService.impersonateExchange;
api.logout = apiService.logout;
api.register = apiService.register;
api.updatePassword = apiService.updatePassword;
api.refreshToken = apiService.refreshToken;
api.setToken = apiService.setToken;
api.getTechnicalSpecs = apiService.getTechnicalSpecs;
api.getTechnicalSpecsNewWave = apiService.getTechnicalSpecsNewWave;
api.updateTechnicalSpec = apiService.updateTechnicalSpec;
api.updateTechnicalSpecFields = apiService.updateTechnicalSpecFields;
api.confirmTZ = apiService.confirmTZ;
api.confirmTZFull = apiService.confirmTZFull;
api.uploadImage = apiService.uploadImage;
api.deleteImage = apiService.deleteImage;
api.swapImages = apiService.swapImages;
api.generateDescription = apiService.generateDescription;
api.pollTzJob = apiService.pollTzJob;
api.getTzTemplates = apiService.getTzTemplates;
api.getTzModels = apiService.getTzModels;
api.getTzUsage = apiService.getTzUsage;
api.getTzBlocks = apiService.getTzBlocks;
api.createTzBlock = apiService.createTzBlock;
api.updateTzBlock = apiService.updateTzBlock;
api.deleteTzBlock = apiService.deleteTzBlock;
api.createTzTemplate = apiService.createTzTemplate;
api.updateTzTemplate = apiService.updateTzTemplate;
api.duplicateTzTemplate = apiService.duplicateTzTemplate;
api.deleteTzTemplate = apiService.deleteTzTemplate;
api.getTzFeedback = apiService.getTzFeedback;
api.rateTzTemplate = apiService.rateTzTemplate;
api.commentTzTemplate = apiService.commentTzTemplate;
api.deleteTzComment = apiService.deleteTzComment;
api.setTzBinding = apiService.setTzBinding;
api.clearTzBinding = apiService.clearTzBinding;
api.getProductPackageInfo = apiService.getProductPackageInfo;
api.updateProductPackageInfo = apiService.updateProductPackageInfo;
api.getAnalystUsers = apiService.getAnalystUsers;
api.transferSubject = apiService.transferSubject;
api.changeSubjectProductsStatus = apiService.changeSubjectProductsStatus;
api.getProductGraphs = apiService.getProductGraphs;
api.getWBCard = apiService.getWBCard;
api.getProductBySku = apiService.getProductBySku;
api.getTzConfirmedWeekCount = apiService.getTzConfirmedWeekCount;
api.getWeeklyStatistics = apiService.getWeeklyStatistics;
api.getWeeklyStatisticsExport = apiService.getWeeklyStatisticsExport;
api.getWeeklyDetail = apiService.getWeeklyDetail;
api.getSubjectDetail = apiService.getSubjectDetail;
api.getProductAuditLog = apiService.getProductAuditLog;
api.getStatisticsAuditLog = apiService.getStatisticsAuditLog;
api.saveNewWaveProduct = apiService.saveNewWaveProduct;
api.getNewWaveProducts = apiService.getNewWaveProducts;
api.checkSkuAvailability = apiService.checkSkuAvailability;
api.getCheckerSearch = apiService.getCheckerSearch;
api.getCheckerSuggestions = apiService.getCheckerSuggestions;
api.getAllSubjects = apiService.getAllSubjects;
api.deleteNewWaveProduct = apiService.deleteNewWaveProduct;
api.addToStopList = apiService.addToStopList;

/** План по ТЗ за неделю: отображаем (X/150). */
export const TZ_CONFIRMED_WEEK_PLAN = 150;

export { api, apiService, loadTzJobs, loadTzResults, forgetTzResult, subscribeTzJobs, ensureTzWatchers, cancelTzGeneration };
export default api;

